<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">受入確認</span>
      </v-card-title>

      <v-card-actions>
        <v-btn @click="search" class="btn-search" v-permit.SHARP_AC_SEARCH>{{
          $t('app.buttons.search')
        }}</v-btn>
        <v-btn
          :disabled="selected.length != 1 || hasBookingDo"
          @click="toSetPattern"
          v-permit.SHARP_AC_PATTERN_SETTING
          >パターン設定</v-btn
        >
        <v-btn
          :disabled="cantSend || selected.length === 0 || hasBookingDo"
          @click="$refs.editLocationDialog.popup()"
          v-permit.SHARP_AC_WAREHOUSE_SAVE
          >納入情報一括変更</v-btn
        >
        <v-btn
          :disabled="selected.length != 1 || !canSend || hasBookingDo"
          @click="acceptConfirm"
          v-permit.SHARP_AC_CONFIRM
          >受入確認</v-btn
        >
        <v-btn
          :disabled="selected.length != 1 || !canCancel || hasBookingDo"
          @click="cancelConfirm"
          v-permit.SHARP_AC_RELEASE
          >受入確認解除</v-btn
        >
        <v-btn
          :disabled="selected.length !== 1 || hasBookingDo"
          @click="updateConteinerNo"
          v-permit.SHARP_AC_CONTAINER_NO_UPDATE
          >コンテナNo更新</v-btn
        >
        <v-btn @click="exportExcelByDate" v-permit.SHARP_AC_DATE_DOWNLOAD
          >搬入予定（日付別）出力</v-btn
        >
        <v-btn @click="exportDark">ドレージ手配出力</v-btn>
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <!-- <v-text-field label="納入場所" v-model="query.location"></v-text-field> -->
              <remote-autocomplete
                label="納入場所"
                url="warehouses/kv"
                v-model="query.finallyWarehouseId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.blNo')"
                clearable
                v-model="query.blNo"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="D/O NO"
                v-model="query.doNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="コンテナNO"
                v-model="query.containerNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-select
                label="運送形態"
                url="transport-modes/kv"
                v-model="query.transportModeId"
              ></remote-select>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                url="ports/kv"
                v-model="query.dischargePortCode"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :label="$t('app.labels.etd')"
                    v-model="query.etdFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.etdFrom"
                    label
                    v-model="query.etdTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :label="$t('app.labels.eta')"
                    v-model="query.etaFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.etaFrom"
                    label
                    v-model="query.etaTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :label="$t('app.labels.shippingAdvice.blIssueDate')"
                    v-model="query.blIssueDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.blIssueDateFrom"
                    label
                    v-model="query.blIssueDateTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    label="納入指示日"
                    v-model="query.warehousingDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.warehousingDateFrom"
                    label
                    v-model="query.warehousingDateTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    label="受入指示日"
                    v-model="query.forecastDeliveryDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.forecastDeliveryDateFrom"
                    label
                    v-model="query.forecastDeliveryDateTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-select
                :items="status"
                clearable
                label="ステータス"
                v-model="query.status"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <fixed-column-wrap :data="results">
        <template slot-scope="{}">
          <v-data-table
            :headers="headers"
            :items="results"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[10]"
            :total-items="pagination.totalItems"
            class="inline-edit"
            item-key="id"
            ref="dt"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>{{ props.item.buCode }}:{{ props.item.buName }}</td>
              <td>{{ props.item.doNo }}</td>
              <td>{{ props.item.branchCode }}</td>
              <td v-if="!props.item.hasBookingSa">
                {{ props.item.containerNos }}
              </td>
              <td style="color: red" v-if="props.item.hasBookingSa">
                {{ props.item.containerNos }}
              </td>
              <td>{{ props.item.forecastDate }}</td>
              <td>{{ props.item.forecastDeliveryDate }}</td>
              <td>{{ props.item.forecastDeliveryTime }}</td>
              <td>{{ props.item.blNo }}</td>
              <td>{{ props.item.status }}</td>
              <!-- {{ props.item.packages[0].containerNo }} -->
              <td>{{ props.item.eta }}</td>
              <td>{{ props.item.etd }}</td>
              <td>{{ props.item.blIssueDate }}</td>
              <td>{{ props.item.dischargePortName }}</td>
              <td>{{ props.item.primarySkuCode }}</td>
              <td>{{ props.item.primaryProductName }}</td>
              <td>{{ props.item.totalQty }}</td>
              <td>{{ props.item.shipName }}</td>
              <td>
                {{ props.item.customsDirectorCode }}:{{
                  props.item.customsDirectorName
                }}
              </td>
              <td>
                {{ props.item.deliverySupplierCode }}:{{
                  props.item.deliverySupplierName
                }}
              </td>
              <td>{{ props.item.containerTypeNames }}</td>
              <td>{{ props.item.warehousingDate }}</td>
              <td>{{ props.item.remark }}</td>
              <td>
                <v-btn style="max-height: 24px" @click="editRemark(props.item)"
                  >編集</v-btn
                >
              </td>
              <td>{{ props.item.finallyWarehouseName }}</td>
              <td>{{ props.item.forecastDate }}</td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
    <edit-location-dialog
      :supplier="supplier"
      @submit="updateLocation"
      ref="editLocationDialog"
    />
    <excel-dialog ref="excelDlg" />
    <message-alert ref="message"></message-alert>
    <update-container-no
      :deliveryOrder="selected[0]"
      @refresh="load"
      ref="updateContainerNo"
    ></update-container-no>
    <edit-remark-dialog @load="load" ref="remark"></edit-remark-dialog>
  </v-container>
</template>

<script>
import EditLocationDialog from './EditLocationDialog'
import ExcelDialog from './ExcelDialog'

import XLSX from 'xlsx'
import book from '@/assets/xlsx/搬入予定（日付別）.xlsx'

import UpdateContainerNo from './UpdateContainerNo'
import EditRemarkDialog from '../B2300/EditRemarkDialog.vue'
export default {
  components: {
    EditLocationDialog,
    ExcelDialog,
    UpdateContainerNo,
    EditRemarkDialog,
  },
  methods: {
    cancelBookingDo() {
      this.$confirm({
        content: '該当事前仮取消して宜しいでしょうか？',
      }).then(
        this.$http
          .put(`delivery-orders/cancel-booking-do/${this.selected[0].id}`)
          .then(() => {
            this.$message('', '事前仮取消が完了しました。')
            this.load()
          })
          .catch(() => {
            this.$message('', '事前仮取消が失敗しました。')
          })
      )
    },
    updateConteinerNo() {
      this.$refs.updateContainerNo.popup()
    },

    exportExcelByDate() {
      // this.$refs.excelDlg.popup().then(query => {
      //   console.log('export Excel params', query)
      //   XLSX.writeFile(book, '搬入予定（日付別）.xlsx')
      // })

      this.$download(`/delivery-orders/reports/ctn-accept/b700`)
    },
    exportDark() {
      this.$download('/delivery-orders/reports/dark', {
        ...this.query,
        ...this.$pageable(),
      })
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    load() {
      this.query.moduleCode = 'F700'
      this.autoload = true
      this.$http.get('/delivery-orders', this.params()).then((res) => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    loadSupplierCompanies() {
      this.$http.get('/companies?companyType=SUPPLIER').then((res) => {
        this.supplier = res.data.content
        this.supplier = this.supplier.filter((i) => i.hasDarke == true)
      })
    },
    back() {
      this.$router.go(-1)
    },
    updateLocation(e) {
      this.selected.forEach((item) => {
        if (e.forecastDeliveryDate != null) {
          item.forecastDeliveryDate = e.forecastDeliveryDate
        }
        if (e.forecastDeliveryTime != null) {
          item.forecastDeliveryTime = e.forecastDeliveryTime
        }
        if (e.finallyWarehouseId != null) {
          item.finallyWarehouseId = e.finallyWarehouseId
        }
      })
      Promise.all(
        this.selected.map((s) => {
          return this.$http.put(`/delivery-orders/${s.id}/acceptance-change`, s)
        })
      )
        .then(() => this.load())
        .catch((err) => {
          this.$showError(err)
        })
    },
    search() {
      this.$storeParams()
      this.pagination.page = 0
      this.load()
    },
    acceptConfirm() {
      if (this.selected.length == 0) {
        this.$message('', '一つのレコードを選んでください。')
      } else if (this.cantSend) {
        this.$message('', '既に受入確認済み。')
      }
      //  else if (
      //   this.selected.map(s => s.routes).filter(r => r.length == 0).length > 0
      // ) {
      //   this.$message('', '配送パータンをご設定ください。')
      // }
      else if (this.canaccept) {
        this.$message('', '既にDO確定済み。')
      } else {
        Promise.all(
          this.selected.map((s) => {
            return this.$http.put(
              `/delivery-orders/${s.id}/acceptance-confirm?version=${s.version}`
            )
          })
        )
          .then(() => {
            this.load()
            this.$message('', '受入確認済')
          })
          .catch((res) => {
            this.$showError(res)
          })
      }
    },
    cancelConfirm() {
      if (this.selected.length !== 1) {
        this.$message('', '一つのD/Oデータをチェックしてください。')
      } else {
        this.$http
          .put(
            `/delivery-orders/${
              this.selected[0].id
            }/acceptance-confirm-cancel?version=${this.selected[0].version}`
          )
          .then(() => {
            this.$message('', '受入確認解除が完了しました。')
            this.load()
          })
          .catch((res) => {
            this.$showError(res)
          })
      }
    },
    toSetPattern() {
      this.$router.push({
        path: '/B0601',
        query: {
          id: this.selected[0].id,
        },
      })
    },
    editRemark(shipment) {
      this.$refs.remark.popup(shipment)
    },
  },
  computed: {
    hasBookingDo() {
      return this.selected.filter((s) => s.type === 'BOOKINGDO').length > 0
    },
    cancelCancelBookingDo() {
      return (
        this.selected.length === 1 &&
        this.selected.filter((s) => s.type === 'BOOKINGDO').length === 1
      )
    },
    visiableHeaders() {
      return this.headers.filter((p) => !p.hide)
    },
    cantSend() {
      return (
        this.selected.filter(
          (s) =>
            s.status !== '納入指示済' &&
            s.actStatus !== '納入指示済' &&
            s.status !== '事前納入指示済'
        ).length > 0
      )
    },
    unsend() {
      return this.selected.map((s) => s.status).filter((s) => s == '納入指示済')
        .length > 0
        ? true
        : false
    },
    sended() {
      return this.selected.map((s) => s.status).filter((s) => s == '受入解除済')
        .length > 0
        ? true
        : false
    },
    canaccept() {
      return this.selected.map((s) => s.status).filter((s) => s == 'DO確定済')
        .length > 0
        ? true
        : false
    },
    canCancel() {
      return this.selected
        .map((s) => s.status)
        .filter((s) => s == '受入確認済' || s === '事前受入確認済').length ==
        this.selected.length ||
        this.selected.map((s) => s.actStatus).filter((s) => s == '受入確認済')
          .length == this.selected.length
        ? true
        : false
    },
    canSend() {
      return this.selected
        .map((s) => s.status)
        .filter(
          (s) =>
            s === '納入指示済' ||
            s === 'SJL送信済' ||
            s === 'SA一時保存-SJL' ||
            s === '事前納入指示済'
        ).length == this.selected.length
        ? true
        : false
    },
  },
  mounted() {
    //this.load()
    this.$loadParams()
    this.loadSupplierCompanies()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
  data: () => ({
    errors: {
      UP_TO_LIMIT: '受入上限本数を超えてしうので、受入確認できません。',
      VIRTUAL_WAREHOUSE: '仮想倉庫で受入確認できません。',
      NO_CONFIG: '当該納入場所を指定できません。',
      SHIPMENT_HAS_CHANGED:
        '当該データのステータスは更新されたため、画面更新してからもう一度お試してください。',
    },
    loading: false,
    results: [],
    selected: [],
    supplier: [],
    query: {
      moduleCode: 'F700',
    },
    pagination: {
      page: 1,
    },
    status: ['納入指示済', '受入確認済'],
    headers: [
      {
        text: '事業本部',
        value: 'buName',
        sortable: false,
        class: 'fixed',
      },
      {
        text: 'D/O NO',
        value: 'doNo',
        sortable: false,
        class: 'fixed',
      },
      {
        text: '枝番',
        value: 'branchCode',
        sortable: false,
        class: 'fixed',
      },
      {
        text: 'コンテナNO',
        value: 'containerNo',
        sortable: false,
        class: 'fixed',
      },
      {
        text: '受入予定日',
        value: 'forecastDate',
        sortable: false,
      },
      {
        text: '纳入予定日期',
        value: 'forecastDeliveryDate',
        sortable: false,
      },
      {
        text: '纳入予定時間',
        value: 'forecastDeliveryTime',
        sortable: false,
      },
      {
        text: 'B/L NO',
        value: 'blNo',
        sortable: false,
      },
      {
        text: 'ステータス',
        value: 'status',
        sortable: false,
      },
      {
        text: 'ETA',
        value: 'eta',
        sortable: false,
      },
      {
        text: 'ETD',
        value: 'etd',
        sortable: false,
      },
      {
        text: 'B/L発行日',
        value: 'blIssueDate',
        sortable: false,
      },
      {
        text: '陸揚港',
        value: 'dischargePortName',
        sortable: false,
      },
      {
        text: '代表品番',
        value: 'skuCode',
        sortable: false,
      },
      {
        text: '品種名',
        value: 'productName',
        sortable: false,
      },
      {
        text: '数量',
        value: 'totalQty',
        sortable: false,
      },
      {
        text: '本船名',
        value: 'shipName',
        sortable: false,
      },
      {
        text: '通関業者',
        value: 'customsDirectorName',
        sortable: false,
      },
      {
        text: 'ドレージ業者',
        value: 'drake',
        sortable: false,
      },
      {
        text: 'コンテナ タイプ',
        value: 'containerType',
        sortable: false,
      },
      {
        text: '納入指示日',
        value: 'forecastDeliveryDate',
        sortable: false,
      },
      {
        text: 'コメント',
        value: 'remark',
        sortable: false,
      },
      {
        text: 'コメント編集',
        value: '',
        sortable: false,
      },
      {
        text: '納入場所',
        value: 'sjlWarehouseName',
        sortable: false,
      },
      {
        text: '受入確認日',
        value: 'confirmDate',
        sortable: false,
      },
    ],
  }),
}
</script>
